import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppPermissions } from '../types/permissions';
import { APP_CONFIG, AppConfig } from '../config/app-config';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  permissionHandlers: Record<AppPermissions, () => Observable<boolean>> = {
    [AppPermissions.ORDER_DELIVERY]: () => {
      return of(this.appConfig.features.deliveryEnabled);
    },
    [AppPermissions.CAN_USE_CREDIT_CARD]: () => {
      return of(this.appConfig.features.creditCardEnabled);
    },
  };

  constructor(@Inject(APP_CONFIG) private readonly appConfig: AppConfig) {}

  has(permission: AppPermissions): Observable<boolean> {
    return this.permissionHandlers[permission]();
  }
}
